module.exports = __webpack_public_path__ + "img/India.2d62b2da.png";